<template>
  <div class="flex justify-center">
    <PrimeButton
      type="button"
      aria-haspopup="true"
      aria-controls="overlay_menu"
      rounded
      style="padding: 0"
      @click="toggle"
    >
      <Avatar />
    </PrimeButton>

    <PrimeMenu
      ref="menu"
      :model="items"
      popup
      class="avatarMenu w-fit min-w-60"
    >
    <template v-if="isChatPage" #start>
      <div  class="px-1 flex items-center justify-between">
        <LanguageSwitcher />
        <ThemeSwitcher />
      </div>
    </template>
    <template #item="{ item, props }">
      <a v-ripple class="flex items-center" v-bind="props.action">
        <span :class="item.icon" />
        <span>{{ $t(item.label) }}</span>
      </a>
    </template>
      
    </PrimeMenu>
    <PrimeDialog
      v-model:visible="visible"
      modal
      dismissable-mask
      :header="$t('components.settings.avatar.settings') + ' > ' + $t('components.settings.menu.' + contentName.toLowerCase())"
      class="h-[500px] max-h-[90vh] w-full max-w-screen-sm overflow-x-hidden max-md:h-[600px] max-md:w-[500px]"
      style="border-radius: 1rem"
    >
      <Menu v-model:show-component="contentName" />
    </PrimeDialog>
  </div>
</template>

<script>
import { mapActions } from 'pinia';
import Avatar from '../profile/Avatar.vue';
import Menu from './Menu.vue';
import LanguageSwitcher from '../layouts/LanguageSwitcher.vue';
import ThemeSwitcher from '../layouts/ThemeSwitcher.vue';

export default defineNuxtComponent({
  components: {
    Avatar,
    Menu,
    LanguageSwitcher,
    ThemeSwitcher
  },
  data() {
    return {
      visible: false,
      contentName: 'Profile',
      items: [
        {
          items: [
            {
              label: 'navigation.upgradePlan',
              icon: 'pi pi-sparkles',
              command: () => {
                const localePath = useLocalePath();
                navigateTo(localePath({ name: 'pricing' }));
              },
            },
          ],
        },
        {
          items: [
            {
              label: 'components.settings.avatar.settings',
              icon: 'pi pi-cog',
              command: () => {
                this.visible = true;
              },
            },
            {
              label: 'components.settings.avatar.logout',
              icon: 'pi pi-sign-out',
              command: async () => {
                await this.handleLogout();
              },
            },
          ],
        },
      ],
    };
  },
  computed: {
    isChatPage() {
      const route = useRoute()
      return route.name.includes('chat')
    }
  },
  methods: {
    ...mapActions(useAuthStore, ['logout']),

    toggle(event) {
      this.$refs.menu.toggle(event);
    },
    async handleLogout() {
      const success = await this.logout();
      if (success) {
        const router = useRouter();
        const localePath = useLocalePath();
        router.push(localePath({ name: 'index' }));
      }
    },
  },
});
</script>

<style>
:deep(.p-menu-submenu-label) {
  padding: 0;
}
.avatarMenu > .p-menu-list > .p-menu-submenu-label {
  padding: 0;
}
</style>
